import React from "react";

import { ActionButton, RegularButton } from "colbi_web_ui/lib/components/inputs";

import styles from "./MultipleDownloadDialog.module.sass";

const MultipleDownloadDialog = (props) => {
    const { data, i18n, cancel } = props;
    const { queries, download, locale, totalLinesCsv, downloadFile, pushDialog } = data;

    const optionButtons = queries.map((elem, index) => {
        const { pathsToDownload } = elem.args;
        if (pathsToDownload) {
            return (
                <ActionButton
                    key={index}
                    className={`${styles["action-button"]} ${styles["download"]}`}
                    onClick={() => {
                        downloadFile &&
                            downloadFile(
                                {
                                    files: [
                                        {
                                            fileLocation:
                                                pathsToDownload &&
                                                pathsToDownload[elem.exportableEntity],
                                        },
                                    ],
                                },
                                pushDialog,
                                i18n,
                            );
                        cancel();
                    }}
                >
                    <strong>{i18n`${[elem.resource, elem.exportableEntity].join("")}`}</strong>
                </ActionButton>
            );
        } else {
            return (
                <ActionButton
                    key={index}
                    className={`${styles["action-button"]} ${styles["download"]}`}
                    onClick={() => {
                        elem.args.selectedExportableOption = elem.exportableEntity;
                        download && download([elem], locale);
                        cancel();
                    }}
                >
                    <strong>{i18n`${[elem.resource, elem.exportableEntity].join("")}`}</strong>
                </ActionButton>
            );
        }
    });

    return (
        <div className={styles["root"]}>
            <div className={styles["content"]}>
                <div className={styles["actions"]}>
                    <div className={styles["options"]}>{optionButtons}</div>
                    <div className={styles["group-content"]}>
                        {totalLinesCsv ? (
                            <small
                                className={styles["lines-limit"]}
                            >{i18n`Limit of ${totalLinesCsv} rows per file`}</small>
                        ) : null}

                        <RegularButton
                            className={`${styles["action-button"]} ${styles["close"]}`}
                            type="button"
                            onClick={() => {
                                cancel && cancel();
                            }}
                        >
                            <strong>{i18n`Close`}</strong>
                        </RegularButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MultipleDownloadDialog;
